// Store behaviour events for the Painel MeuCompra: anonymous, no cookies, no names, e-mails or addresses. Sent in small
// batches to PostHog, without its SDK, so the page stays light. Reads cart answers by wrapping fetch, so no purchase code
// changes, and anything failing here is swallowed: tracking must never break the store.
// Own visits: open the store once with ?mc_notrack=1. Test events: localStorage mc_track=test (filtered out of the panel).
(function () {
  var C = window.MC_TRACK; if (!C) return;
  var ls = function (k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } };
  var ss = function (k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } };
  var params = new URLSearchParams(location.search);
  if (params.get('mc_notrack') === '1') ls('mc_track', 'off');
  if (params.get('mc_notrack') === '0') ls('mc_track', '');
  var mode = ls('mc_track'), test = mode === 'test' || C.theme !== 'main';
  if (mode === 'off' || C.designMode || (navigator.webdriver && mode !== 'test')) return;
  if (navigator.doNotTrack === '1' || navigator.globalPrivacyControl === true) return;
  if (/bot|crawl|spider|slurp|preview|headless|lighthouse/i.test(navigator.userAgent) && mode !== 'test') return;

  var id = function () { return (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2)); };
  var vid = ls('mc_vid'); if (!vid) { vid = id(); ls('mc_vid', vid); }
  var now = Date.now(), last = +ss('mc_last') || 0, sid = ss('mc_sid');
  if (!sid || now - last > 18e5) {
    sid = id(); ss('mc_sid', sid);
    var ref = ''; try { ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''; } catch (e) {}
    if (ref === location.hostname.replace(/^www\./, '')) ref = '';
    ss('mc_src', JSON.stringify({ ref: ref, src: params.get('utm_source') || '', med: params.get('utm_medium') || '', cmp: params.get('utm_campaign') || '', ad: params.get('utm_content') || '', land: location.pathname }));
  }
  var src = {}; try { src = JSON.parse(ss('mc_src')) || {}; } catch (e) {}
  var device = matchMedia('(max-width: 760px)').matches ? 'mobile' : 'desktop';
  var queue = [], timer = null, lastCart = null;

  function flush(leaving) {
    timer = null; if (!queue.length) return;
    try { if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed && Shopify.customerPrivacy.analyticsProcessingAllowed() === false) { queue = []; return; } } catch (e) {}
    var body = JSON.stringify({ api_key: C.key, batch: queue }); queue = [];
    try {
      if (leaving && navigator.sendBeacon && navigator.sendBeacon(C.host + '/batch/', new Blob([body], { type: 'text/plain' }))) return;
      origFetch(C.host + '/batch/', { method: 'POST', body: body, headers: { 'Content-Type': 'application/json' }, keepalive: true, credentials: 'omit' }).catch(function () {});
    } catch (e) {}
  }
  function track(event, props) {
    try {
      ss('mc_last', String(Date.now()));
      var p = { $process_person_profile: false, $geoip_disable: true, $current_url: location.origin + location.pathname, sid: sid, device: device, page: C.type, lang: C.lang, ref: src.ref, utm_source: src.src, utm_medium: src.med, utm_campaign: src.cmp, utm_content: src.ad, land: src.land };
      if (test) p.test = true;
      for (var k in props) p[k] = props[k];
      queue.push({ event: event, distinct_id: vid, timestamp: new Date().toISOString(), properties: p });
      if (queue.length >= 10) flush(); else if (!timer) timer = setTimeout(flush, 3000);
    } catch (e) {}
  }
  var cartInfo = function (c) { return c ? { cart_items: c.item_count, cart_value: (c.total_price || 0) / 100, cart_handles: (c.items || []).map(function (i) { return i.handle; }) } : {}; };
  var line = function (i) { return { handle: i.handle, product_id: String(i.product_id), variant_id: String(i.variant_id || i.id), title: i.product_title, variant: i.variant_title || '', price: (i.price || 0) / 100, qty: i.quantity, value: (i.final_line_price || i.price * i.quantity || 0) / 100 }; };
  var origFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    var promise = origFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '', method = (init && init.method || (input && input.method) || 'GET').toUpperCase();
      if (/\/cart(\/(add|change|update))?(\.js)?(\?|$)/.test(url.split('#')[0])) {
        promise.then(function (res) {
          if (!res.ok) { if (method === 'POST' && /\/cart\/add/.test(url)) track('add_to_cart_failed', { status: res.status }); return; }
          res.clone().json().then(function (data) {
            if (method !== 'POST') { if (data && data.items) lastCart = data; return; }
            if (/\/cart\/add/.test(url)) {
              var items = data.items || (data.handle ? [data] : []);
              items.forEach(function (i) { track('add_to_cart', line(i)); });
            } else if (/\/cart\/change/.test(url)) {
              var body = {}; try { body = JSON.parse(init.body); } catch (e) {}
              lastCart = data;
              track(body.quantity === 0 ? 'remove_from_cart' : 'cart_quantity', Object.assign({ qty: body.quantity }, cartInfo(data)));
            } else if (data && data.items) lastCart = data;
          }).catch(function () {});
        }, function () {});
      }
    } catch (e) {}
    return promise;
  };

  track('page_view', C.product ? { handle: C.product.handle, product_id: C.product.id, title: C.product.title, price: C.product.price } : { path: location.pathname });
  if (C.product) track('product_view', { handle: C.product.handle, product_id: C.product.id, title: C.product.title, price: C.product.price });
  if (C.type === 'cart') track('cart_view', {});
  if (C.type === 'search' && C.q) track('search', { q: String(C.q).toLowerCase().slice(0, 60), results: C.results });

  var isBuyPrompt = function (b) { return /escolha sua|choose your|elige tu/i.test(b.textContent || ''); };
  document.addEventListener('click', function (e) {
    try {
      var t = e.target.closest && e.target.closest('a,button'); if (!t) return;
      var href = t.getAttribute('href') || '', h = C.product && C.product.handle;
      if (t.tagName === 'BUTTON' && isBuyPrompt(t)) track('buy_without_option', { handle: h });
      else if (t.matches('[data-share-to]')) track('share', { channel: t.getAttribute('data-share-to'), handle: h });
      else if (t.matches('[data-share-copy]')) track('share', { channel: 'copy', handle: h });
      else if (t.closest('.assistant-launcher')) track('bot_open', { handle: h });
      else if (t.matches('[data-hero-link],[data-hero-stage]')) track('hero_click', { href: href });
      else if (/\/cart\/?$/.test(href)) track('cart_open', {});
      else if (/\/checkout/.test(href)) { track('begin_checkout', cartInfo(lastCart)); flush(true); }
      else if (/\/products\//.test(href)) track('product_click', { handle: href.split('/products/')[1].split(/[?#]/)[0], from: C.type });
    } catch (err) {}
  }, true);
  document.addEventListener('submit', function (e) {
    try { var f = e.target, a = f.getAttribute('action') || ''; if (/\/(cart|checkout)/.test(a) && (f.id === 'drawer-checkout-form' || f.querySelector('[name=checkout],#checkout'))) { track('begin_checkout', cartInfo(lastCart)); flush(true); } } catch (err) {}
  }, true);
  document.addEventListener('change', function (e) {
    try { if (e.target.id === 'variant-select' && e.target.value) track('variant_select', { handle: C.product && C.product.handle, variant_id: e.target.value, variant: (e.target.selectedOptions[0].textContent || '').trim().split(' — ')[0].slice(0, 80) }); } catch (err) {}
  }, true);

  // How far and how long, once per page, only on product pages.
  var depth = 0, started = Date.now();
  if (C.product) addEventListener('scroll', function () { var d = (scrollY + innerHeight) / Math.max(1, document.documentElement.scrollHeight); if (d > depth) depth = d; }, { passive: true });
  var left = false;
  addEventListener('pagehide', function () {
    if (C.product && !left) { left = true; track('product_leave', { handle: C.product.handle, seconds: Math.round((Date.now() - started) / 1000), depth: Math.round(depth * 100) }); }
    flush(true);
  });
  addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(true); });
})();
